/**
 * Build-time configuration.
 *
 * Only `VITE_`-prefixed variables reach the bundle, and everything here is
 * public by definition — it ships to every browser. Never add a secret.
 *
 * Validated at module load so a missing variable is a blank page with a clear
 * console error at startup, rather than a request to `undefined/employees`
 * failing somewhere deep in the app.
 *
 * Hand-rolled rather than zod, which this file used to import. Everything in
 * the app imports `env`, so that import pulled the whole schema library into
 * the entry chunk — 45 KB on the critical path of every page load, to check
 * that two strings are strings. zod now travels with the forms that validate
 * what people type, which is the work it is worth its size for.
 */
function fromEnv(name: 'VITE_API_BASE_URL' | 'VITE_APP_NAME', fallback: string): string {
  const value: unknown = import.meta.env[name];

  // Absent and empty are both "not configured". The old schema accepted an
  // empty string, which passed validation and then broke every request with a
  // base URL of nothing — a defaulted value is the more useful answer.
  if (value === undefined || value === '') return fallback;

  if (typeof value !== 'string') {
    throw new Error(`Invalid frontend environment:\n${name}: expected a string`);
  }

  return value;
}

export const env = {
  VITE_API_BASE_URL: fromEnv('VITE_API_BASE_URL', '/api/v1'),
  VITE_APP_NAME: fromEnv('VITE_APP_NAME', 'KioBytes HR'),
};
